/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Home_DescriptionInputs */

const he_seo_home_description = /** @type {(inputs: Seo_Home_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עקבו אחרי מחירי מוצרי KSP, השוו היסטוריית מחירים ומצאו את הזמן הנכון לקנות. התראות מחיר חינם ותוסף דפדפן.`)
};

const en_seo_home_description = /** @type {(inputs: Seo_Home_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track prices of KSP products, compare price history and find the best time to buy. Free price alerts and browser extension.`)
};

/**
* | output |
* | --- |
* | "Track prices of KSP products, compare price history and find the best time to buy. Free price alerts and browser extension." |
*
* @param {Seo_Home_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const seo_home_description = /** @type {((inputs?: Seo_Home_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Home_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_home_description(inputs)
	return en_seo_home_description(inputs)
});